var _defs, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 290,
    zoomAndPan: "magnify",
    viewBox: "0 0 217.5 217.499992",
    height: 290,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "686d35ea3d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.792969 49.792969 L 167.273438 49.792969 L 167.273438 167.273438 L 49.792969 167.273438 Z M 49.792969 49.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "46e260d3cd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 76.402344 84 L 140.753906 84 L 140.753906 133.171875 L 76.402344 133.171875 Z M 76.402344 84 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "35761490be"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.792969 49.792969 L 167.273438 49.792969 L 167.273438 167.273438 L 49.792969 167.273438 Z M 49.792969 49.792969 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#686d35ea3d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3184c9",
    d: "M 149.140625 49.792969 L 67.855469 49.792969 C 57.878906 49.792969 49.792969 57.878906 49.792969 67.855469 L 49.792969 149.140625 C 49.792969 159.113281 57.878906 167.203125 67.855469 167.203125 L 149.140625 167.203125 C 159.113281 167.203125 167.203125 159.113281 167.203125 149.140625 L 167.203125 67.855469 C 167.203125 57.878906 159.113281 49.792969 149.140625 49.792969 Z M 158.171875 149.140625 C 158.171875 154.125 154.121094 158.171875 149.140625 158.171875 L 67.855469 158.171875 C 62.871094 158.171875 58.824219 154.125 58.824219 149.140625 L 58.824219 67.855469 C 58.824219 62.875 62.871094 58.824219 67.855469 58.824219 L 149.140625 58.824219 C 154.121094 58.824219 158.171875 62.875 158.171875 67.855469 Z M 158.171875 149.140625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#46e260d3cd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3184c9",
    d: "M 138.578125 85.804688 C 136.558594 83.785156 133.285156 83.785156 131.269531 85.804688 L 98.472656 118.597656 L 85.734375 105.855469 C 83.714844 103.835938 80.441406 103.835938 78.421875 105.855469 C 76.402344 107.875 76.402344 111.148438 78.421875 113.167969 L 94.820312 129.5625 L 98.472656 133.21875 L 138.578125 93.113281 C 140.597656 91.09375 140.597656 87.820312 138.578125 85.804688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#35761490be)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3184c9",
    d: "M 149.140625 49.792969 L 67.855469 49.792969 C 57.878906 49.792969 49.792969 57.878906 49.792969 67.855469 L 49.792969 149.140625 C 49.792969 159.113281 57.878906 167.203125 67.855469 167.203125 L 149.140625 167.203125 C 159.113281 167.203125 167.203125 159.113281 167.203125 149.140625 L 167.203125 67.855469 C 167.203125 57.878906 159.113281 49.792969 149.140625 49.792969 Z M 158.171875 149.140625 C 158.171875 154.125 154.121094 158.171875 149.140625 158.171875 L 67.855469 158.171875 C 62.871094 158.171875 58.824219 154.125 58.824219 149.140625 L 58.824219 67.855469 C 58.824219 62.875 62.871094 58.824219 67.855469 58.824219 L 149.140625 58.824219 C 154.121094 58.824219 158.171875 62.875 158.171875 67.855469 Z M 158.171875 149.140625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.97675ec28c457e4900783f670c36b167.svg";
export { ForwardRef as ReactComponent };